<template>
  <div class="loading-map">
    <div class="loading-map__container">
      <div class="loading-map__illustration">
        <img width="215" src="@/assets/images/upload-in-progress.png" />
      </div>
      <div class="loading-map__text">
        <p>{{ $t('routeOptimization.alert.inProgress') }}</p>
        <p>{{ $t('routeOptimization.alert.continueOther') }}</p>
      </div>
      <div class="loading-map__action-buttons">
        <McButton
          variant="secondary"
          :text="$t('routeOptimization.action.viewSettings')"
          @click="
            $router.push({
              name: 'Route Optimization Detail Setting',
              params: { id: $route.params.id },
            })
          "
        />
        <McButton v-if="false" variant="secondary-red" :text="$t('routeOptimization.action.cancelOptimization')" @click="isOpenCancelModal = true" />

        <McConfirmation
          v-model="isOpenCancelModal"
          :title="$t('routeOptimization.action.cancelOptimization')"
          :okTitle="$t('global.action.close')"
          :cancelTitle="$t('global.action.confirmCancel')"
          centered
          no-close-on-backdrop
          no-close-on-esc
          @cancel="handleCancelRO"
          @handle-ok="isOpenCancelModal = false"
        >
        <div>
          <p class="m-0">{{ $t('routeOptimization.alert.confirmCancel') }}</p>
          <p class="m-0">{{ $t('routeOptimization.alert.unsavedWarning') }}</p>
        </div>``
        </McConfirmation>
      </div>
    </div>
  </div>
</template>

<script>
import McButton from '@/components/McButton'
import McConfirmation from '@/components/McConfirmation'

import * as RO from '@/services/rest-api/lib/route-optimization'

export default {
  components: {
    McButton,
    McConfirmation,
  },
  data() {
    return {
      isOpenCancelModal: false,
    }
  },
  methods: {
    async handleCancelRO() {
      const res = await RO.cancel(this.$route.params.id)

      if (res.errors) {
        this.$mcToast.error(this.$t('routeOptimization.alert.inputFormatError'))
        this.isOpenCancelModal = false
        return
      }

      this.$mcToast.success(this.$t('routeOptimization.alert.cancelSuccess'))
      this.$router.push({ name: 'Route Optimization' })
    },
  },
}
</script>

<style lang="scss" scoped>
.loading-map {
  width: 100%;
  height: 550px;

  &__container {
    margin: 20px auto;
    width: 50%;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__illustration {
    margin: auto;
  }

  &__text {
    text-align: center;
    color: $mep-color-text-400;

    p {
      margin: 0;
    }
  }

  &__action-buttons {
    display: flex;
    justify-content: center;
    gap: 12px;
  }
}
</style>
